import { useNavigate } from 'react-router-dom';
import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { useUserContext } from '../../../contexts/UserContext';
import { getStatusBadge, formatDate } from '../../../utils/subscriptionUtils';
import { Btn } from '../../ui';

export const SubscriptionSection = () => {
    const navigate = useNavigate();
    const { accountStatus, isTrialActive } = useSubscriptionContext();
    const { company } = useUserContext();

    const companyData = company as Record<string, unknown> | null;
    const statusBadge = getStatusBadge(accountStatus);
    const nextBillingDate = companyData?.nextBillingDate as string | null;
    const trialEndDate = companyData?.trialEndDate as string | null;
    const billingCycle = (companyData?.billingCycle as string) || 'Monthly';

    const planName = isTrialActive ? 'Free Demo — Full Access' : 'Core Plan with Add-ons';
    const renewalDate = isTrialActive ? trialEndDate : nextBillingDate;

    return (
        <section className="settings-section">
            <div className="settings-section-header">
                <div>
                    <h2 className="settings-section-title">Subscription</h2>
                    <p className="settings-section-subtitle">Your current plan and renewal details</p>
                </div>
            </div>

            <div className="settings-section-body">
                <div className="subscription-summary-card">
                    <div className="subscription-summary-badge-row">
                        <span className={`subscription-summary-status badge-${statusBadge.variant}`}>
                            {statusBadge.label.toUpperCase()}
                        </span>
                    </div>
                    <h3 className="subscription-summary-plan-name">{planName}</h3>
                    <p className="subscription-summary-desc">View and manage all modules below.</p>

                    <div className="subscription-summary-details">
                        <div className="subscription-summary-detail">
                            <span className="subscription-summary-detail-label">STATUS</span>
                            <span className="subscription-summary-detail-value">● {statusBadge.label}</span>
                        </div>
                        <div className="subscription-summary-detail">
                            <span className="subscription-summary-detail-label">RENEWS ON</span>
                            <span className="subscription-summary-detail-value">{formatDate(renewalDate)}</span>
                        </div>
                        <div className="subscription-summary-detail">
                            <span className="subscription-summary-detail-label">BILLING CYCLE</span>
                            <span className="subscription-summary-detail-value">{billingCycle}</span>
                        </div>
                    </div>

                    <div className="subscription-summary-actions">
                        <Btn
                            variant="primary"
                            buttonSize="sm"
                            buttonText="⇄ Manage Subscription"
                            buttonOnClick={() => navigate('/manage/subscription')}
                        />
                        <Btn
                            variant="secondary-outlined"
                            buttonSize="sm"
                            buttonText="Contact Sales"
                            buttonOnClick={() => {/* TODO: open ContactSalesModal */ }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
